import { EpicsAction } from './types';

export const triggerEpicsAdded = (name: string): EpicsAction => ({
  type: 'EPICS_ADDED',
  payload: {
    name,
  },
});

export default triggerEpicsAdded;
